import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from 'context/authContext';
import { notifyInform } from 'utils/toast';

const ContributorPrivateRoute = ({ children, ...rest }) => {
  const { state } = useContext(AuthContext);
  const { userInfo } = state;

  !userInfo?.email && notifyInform('Please login first')

  console.log(state)

  return (
    userInfo?.email ? (
            children
            ) : (
              <>
                <Navigate to="/contributor-login" replace />
              </>
            )
  );
};

export default ContributorPrivateRoute;
